// Types de serveurs disponibles avec leurs couleurs associées
export const serverTypes = [
  { value: 'Serveur applicatif', color: '#10B981', gradient: 'linear-gradient(135deg, #10B981, #34D399)', icon: 'server-stack' }, // Vert
  { value: 'Serveur base de données', color: '#F59E0B', gradient: 'linear-gradient(135deg, #F59E0B, #FBBF24)', icon: 'database' }, // Orange
  { value: 'Serveur interop', color: '#8B5CF6', gradient: 'linear-gradient(135deg, #8B5CF6, #A78BFA)', icon: 'arrows-right-left' }, // Violet
  { value: 'Serveur tout-en-un', color: '#3B82F6', gradient: 'linear-gradient(135deg, #3B82F6, #60A5FA)', icon: 'cube' } // Bleu
];

// Modèle pour un nouveau serveur avec toutes les propriétés nécessaires
export const getEmptyServer = () => {
  const defaultType = serverTypes[3]; // Serveur tout-en-un par défaut
  return {
    name: '',
    type: defaultType.value, // Type de serveur par défaut
    os: '',
    color: defaultType.color, // Couleur par défaut (bleu)
    gradient: defaultType.gradient, // Gradient par défaut
    icon: defaultType.icon, // Icône par défaut
    ram: '',
    cpu: '',
    diskSpace: '',
    appInstallFolder: '',
    mariadbVersion: '',
    dbInstallFolder: '',
    dbOptimized: undefined, // Non défini par défaut pour détecter les serveurs incomplets
    apacheVersion: '',
    nodejsVersion: '',
    gitPatientAppVersion: '',
    gitManagerFrontAppVersion: '',
    gitMarshallerVersion: '',
    gitMarshallerInteropVersion: '',
    probeDeployed: undefined, // Non défini par défaut pour détecter les serveurs incomplets
    // NOUVEAU: Propriétés SSH
    sshAccessible: false, // Serveur accessible en SSH direct (sans bastion)
    sshUsername: 'root', // Utilisateur SSH par défaut
    sshPort: '22', // Port SSH par défaut
    // Propriétés pour les modifications locales
    localModifications: {
      patientApp: [],
      managerFrontApp: [],
      marshaller: [],
      marshallerInterop: []
    }
  };
};

// Modèle pour une modification locale
export const getEmptyLocalModification = () => ({
  id: Date.now(), // Un ID unique basé sur le timestamp
  filename: '',
  description: '',
  code: '',
  date: new Date().toISOString()
});

// Modèle pour un nouveau client
export const getEmptyClient = () => ({
  name: '',
  description: '',
  environment: '',
  // Nouvelles propriétés pour les URL des portails
  patientPortalUrl: '',
  carePortalUrl: '',
  connectionProcedure: '',
  remoteMaintenance: false, // Booléen pour la télémaintenance
  slackChannelId: '', // ID du canal Slack pour les notifications
  checkGeneral: {
    prod: '',
    qual: ''
  },
  servers: [getEmptyServer()],
  // Historique des mises à jour
  updates: []
});
